import { styled, Typography } from '@mui/material';

export const ButtonsW = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: 24px;
  @media (max-width: 1023px) {
    align-items: baseline;
  }
`;

export const LabelTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '24px',
  color: theme.palette.primary.p080,
  marginBottom: '16px',
  marginLeft: '10px',
  [theme.breakpoints.down('desktop')]: {
    marginBottom: '8px',
  },
}));
